import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SessionLayoutComponent } from './layouts/session-layout/session-layout.component';
import { LogInPageComponent } from './pages/log-in-page/log-in-page.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { DashboardPageComponent } from './pages/dashboard/dashboard-page/dashboard-page.component';
import { NeighborhoodsPageComponent } from './pages/dashboard/neighborhoods-page/neighborhoods-page.component';
import { NeighborhoodTypesPageComponent } from './pages/dashboard/neighborhood-types-page/neighborhood-types-page.component';
import { ProofTypesPageComponent } from './pages/dashboard/proof-types-page/proof-types-page.component';
import { VisitTypesPageComponent } from './pages/dashboard/visit-types-page/visit-types-page.component';
import { ModulesPageComponent } from './pages/dashboard/security/modules-page/modules-page.component';
import { ProfilesPageComponent } from './pages/dashboard/security/profiles-page/profiles-page.component';
import { UsersPageComponent } from './pages/dashboard/security/users-page/users-page.component';
import { UserPageComponent } from './pages/dashboard/security/user-page/user-page.component';
import { NeighborhoodLayoutComponent } from './layouts/neighborhood-layout/neighborhood-layout.component';
import { NeighborhoodPageComponent } from './pages/neighborhood/neighborhood-page/neighborhood-page.component';
import { SettlersPageComponent } from './pages/neighborhood/settlers-page/settlers-page.component';
import { StreetsBuildingPageComponent } from './pages/neighborhood/streets-building-page/streets-building-page.component';
import { HousesFlatsPageComponent } from './pages/neighborhood/houses-flats-page/houses-flats-page.component';
import { VisitsPageComponent } from './pages/neighborhood/visits-page/visits-page.component';
import { SettingsModulesPageComponent } from './pages/neighborhood/settings/settings-modules-page/settings-modules-page.component';
import { SettingsProfilesPageComponent } from './pages/neighborhood/settings/settings-profiles-page/settings-profiles-page.component';
import { GeneralPageComponent } from './pages/neighborhood/settings/general-page/general-page.component';
import { AddressPageComponent } from './pages/neighborhood/settings/address-page/address-page.component';
import { NotificationTypesPageComponent } from './pages/dashboard/catalogues/notification-types-page/notification-types-page.component';
import { ServicesPageComponent } from './pages/neighborhood/settings/services-page/services-page.component';
import { AnnouncementsPageComponent } from './pages/neighborhood/announcements-page/announcements-page.component';
import { NoticeViolationsPageComponent } from './pages/neighborhood/notice-violations-page/notice-violations-page.component';
import { HouseFlatNoticeViolationsPageComponent } from './pages/neighborhood/house-flat-notice-violations-page/house-flat-notice-violations-page.component';
import { GuardsPageComponent } from './pages/dashboard/guards-page/guards-page.component';
import { EmergencyNumbersPageComponent } from './pages/neighborhood/emergency-numbers-page/emergency-numbers-page.component';
import { PaymentsPageComponent } from './pages/neighborhood/payments-page/payments-page.component';
import { BankAccountTypesPageComponent } from './pages/dashboard/bank-account-types-page/bank-account-types-page.component';
import { BankAccountsPageComponent } from './pages/dashboard/bank-accounts-page/bank-accounts-page.component';
import { PaymentPageComponent } from './pages/neighborhood/payment-page/payment-page.component';
import { PlatformsPageComponent } from './pages/dashboard/platforms-page/platforms-page.component';
import { PlatformPageComponent } from './pages/dashboard/platform-page/platform-page.component';
import { ParcelServicesPageComponent } from './pages/dashboard/parcel-services-page/parcel-services-page.component';
import { MovementsPageComponent } from './pages/dashboard/movements-page/movements-page.component';
import { MovementsCreditsPageComponent } from './pages/neighborhood/movements-credits-page/movements-credits-page.component';
import { GatesPageComponent } from './pages/neighborhood/gates-page/gates-page.component';
import { AccessDoorGroupTypesPageComponent } from './pages/neighborhood/access-door-group-types-page/access-door-group-types-page.component';
import { TagTypesPageComponent } from './pages/dashboard/tag-types-page/tag-types-page.component';
import { GatePageComponent } from './pages/dashboard/gate-page/gate-page.component';
import { RulesPageComponent } from './pages/neighborhood/settings/rules-page/rules-page.component';
import { AmenitiesPageComponent } from './pages/neighborhood/amenities-page/amenities-page.component';
import { BookingsPageComponent } from './pages/neighborhood/bookings-page/bookings-page.component';
import { SurveysPageComponent } from './pages/neighborhood/surveys-page/surveys-page.component';
import { SurveyPageComponent } from './pages/neighborhood/survey-page/survey-page.component';
import { SosLogsPageComponent } from './pages/neighborhood/sos-logs-page/sos-logs-page.component';
import { AdministratorsPageComponent } from './pages/dashboard/administrators-page/administrators-page.component';
import { CamerasPageComponent } from './pages/neighborhood/cameras-page/cameras-page.component';
import { HouseFlatPasesPageComponent } from './pages/neighborhood/house-flat-pases-page/house-flat-pases-page.component';
import { NeighborhoodPassesPageComponent } from './pages/neighborhood/neighborhood-passes-page/neighborhood-passes-page.component';
import { ReportsPageComponent } from './pages/neighborhood/reports-page/reports-page.component';
import { PackagesPageComponent } from './pages/neighborhood/packages-page/packages-page.component';
import { SettingsPassesPageComponent } from './pages/neighborhood/settings/settings-passes-page/settings-passes-page.component';
import { SettingsPaymentsPageComponent } from './pages/neighborhood/settings/settings-payments-page/settings-payments-page.component';
import { AccessDoorTypesPageComponent } from './pages/dashboard/access-door-types-page/access-door-types-page.component';
import { HouseFlatPaymentsPageComponent } from './pages/neighborhood/house-flat-payments-page/house-flat-payments-page.component';
import { PaymentMethodsPageComponent } from './pages/dashboard/catalogues/payment-methods-page/payment-methods-page.component';
import { ExternalServiceLogsPageComponent } from './pages/shared/external-service-logs-page/external-service-logs-page.component';
import { ExternalServiceLogPageComponent } from './pages/shared/external-service-log-page/external-service-log-page.component';
import { McpSessionsPageComponent } from './pages/dashboard/mcp-sessions-page/mcp-sessions-page.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: SessionLayoutComponent,
    children: [
      {
        path: 'login',
        component: LogInPageComponent,
        title: 'Iniciar sesión'
      }
    ]
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    children: [
      {
        path: '',
        component: DashboardPageComponent,
        title: 'Dashboard'
      },
      {
        path: 'neighborhoods',
        component: NeighborhoodsPageComponent,
        title: 'Colonias'
      },
      {
        path: 'catalogues',
        children: [
          {
            path: 'access-door-group-types',
            component: AccessDoorGroupTypesPageComponent,
            title: 'Tipos de grupos de acceso'
          },
          {
            path: 'access-door-types',
            component: AccessDoorTypesPageComponent,
            title: 'Tipos de puertas de acceso'
          },
          {
            path: 'parcel-services',
            component: ParcelServicesPageComponent,
            title: 'Paqueterías'
          },
          {
            path: 'neighborhood-types',
            component: NeighborhoodTypesPageComponent,
            title: 'Tipos de colonias'
          },
          {
            path: 'bank-account-types',
            component: BankAccountTypesPageComponent,
            title: 'Tipos de cuentas bancarias'
          },
          {
            path: 'notification-types',
            component: NotificationTypesPageComponent,
            title: 'Tipos de notificaciones'
          },
          {
            path: 'payment-methods',
            component: PaymentMethodsPageComponent,
            title: 'Métodos de pago'
          },
          {
            path: 'proof-types',
            component: ProofTypesPageComponent,
            title: 'Tipos de pruebas'
          },
          {
            path: 'tag-types',
            component: TagTypesPageComponent,
            title: 'Tipos de tags'
          },
          {
            path: 'visit-types',
            component: VisitTypesPageComponent,
            title: 'Tipos de visita'
          }
        ]
      },
      {
        path: 'platforms',
        children: [
          {
            path: '',
            component: PlatformsPageComponent,
            title: 'Soporte'
          },
          {
            path: ':platformId',
            component: PlatformPageComponent,
            title: 'Detalle de plataforma'
          }
        ]
      },
      {
        path: 'security',
        children: [
          {
            path: 'modules',
            component: ModulesPageComponent,
            title: 'Módulos'
          },
          {
            path: 'profiles',
            component: ProfilesPageComponent,
            title: 'Perfiles'
          },
          {
            path: 'users',
            children: [
              {
                path: '',
                component: UsersPageComponent,
                title: 'Usuarios'
              },
              {
                path: ':uid',
                component: UserPageComponent,
                title: 'Detalle de usuario'
              }
            ]
          }
        ]
      },
      {
        path: 'external-service-logs',
        component: ExternalServiceLogsPageComponent,
        title: 'Bitácora de servicios externos'
      },
      {
        path: 'external-service-logs/:externalServiceLogId',
        component: ExternalServiceLogPageComponent,
        title: 'Detalle de bitácora de servicio externo'
      },
      {
        path: 'mcp',
        component: McpSessionsPageComponent,
        title: 'Sesiones MCP'
      },
    ]
  },
  {
    path: 'neighborhoods',
    component: NeighborhoodLayoutComponent,
    children: [
      {
        path: ':neighborhoodId',
        children: [
          {
            path: '',
            component: NeighborhoodPageComponent,
            title: 'Dashboard de colonia'
          },
          {
            path: 'administrators',
            component: AdministratorsPageComponent,
            title: 'Administradores'
          },
          {
            path: 'amenities',
            component: AmenitiesPageComponent,
            title: 'Amenidades'
          },
          {
            path: 'bookings',
            component: BookingsPageComponent,
            title: 'Reservaciones'
          },
          {
            path: 'cameras',
            component: CamerasPageComponent,
            title: 'Cámaras'
          },
          {
            path: 'gates',
            children: [
              {
                path: '',
                component: GatesPageComponent,
                title: 'Accesos'
              },
              {
                path: ':gateId',
                component: GatePageComponent,
                title: 'Detalle de acceso'
              }
            ]
          },
          {
            path: 'guards',
            component: GuardsPageComponent,
            title: 'Vigilantes'
          },
          {
            path: 'movements',
            children: [
              {
                path: '',
                component: MovementsPageComponent,
                title: 'Movimiento'
              },
              {
                path: 'credits',
                component: MovementsCreditsPageComponent,
                title: 'Casas con crédito'
              }
            ]
          },
          {
            path: 'packages',
            component: PackagesPageComponent,
            title: 'Paquetes'
          },
          {
            path: 'passes',
            component: NeighborhoodPassesPageComponent,
            title: 'Pases'
          },
          {
            path: 'payments',
            children: [
              {
                path: '',
                component: PaymentsPageComponent,
                title: 'Mantenimiento'
              },
              {
                path: ':paymentId',
                component: PaymentPageComponent,
                title: 'Detalle de cuota'
              }
            ]
          },
          {
            path: 'reports',
            children: [
              /* La bandeja viaja como segmento de ruta, así que `/reports` a
                 secas se normaliza a la pestaña por defecto: todas las
                 pestañas comparten la misma configuración de ruta y cambiar de
                 pestaña reusa el componente en vez de reconstruirlo. */
              {
                path: '',
                redirectTo: 'pendings',
                pathMatch: 'full'
              },
              {
                path: ':tab',
                component: ReportsPageComponent,
                title: 'Reportes'
              }
            ]
          },
          {
            path: 'settlers',
            component: SettlersPageComponent,
            title: 'Colonos'
          },
          {
            path: 'streets-buildings',
            children: [
              {
                path: '',
                component: StreetsBuildingPageComponent,
                title: 'Casas'
              },
              {
                path: ':streetBuildingId/houses-flats/:houseFlatId/passes',
                component: HouseFlatPasesPageComponent,
                title: 'Pases de vivienda'
              }
            ]
          },
          {
            path: 'houses-flats',
            component: HousesFlatsPageComponent,
            title: 'Viviendas'
          },
          {
            path: 'streets-buildings/:streetBuildingId/houses-flats/:houseFlatId/payments',
            component: HouseFlatPaymentsPageComponent,
            title: 'Pagos de vivienda'
          },
          {
            path: 'streets-buildings/:streetBuildingId/houses-flats/:houseFlatId/notice-violations',
            component: HouseFlatNoticeViolationsPageComponent,
            title: 'Amonestaciones de vivienda'
          },
          {
            path: 'visits',
            component: VisitsPageComponent,
            title: 'Visitas'
          },
          {
            path: 'announcements',
            component: AnnouncementsPageComponent,
            title: 'Anuncios'
          },
          {
            path: 'notice-violations',
            component: NoticeViolationsPageComponent,
            title: 'Amonestaciones'
          },
          {
            path: 'settings',
            children: [

              {
                path: 'modules',
                component: SettingsModulesPageComponent,
                title: 'Módulos de colonia'
              },
              {
                path: 'profiles',
                component: SettingsProfilesPageComponent,
                title: 'Perfiles de colonia'
              },
              {
                path: 'bank-accounts',
                component: BankAccountsPageComponent,
                title: 'Cuentas bancarias'
              },
              {
                path: 'emergency-numbers',
                component: EmergencyNumbersPageComponent,
                title: 'Números de emergencia'
              },
              {
                path: 'services',
                component: ServicesPageComponent,
                title: 'Servicios'
              },
              // {
              //   path: 'proof-types',
              //   component: SettingsProofTypesPageComponent
              // }
              {
                path: 'rules',
                component: RulesPageComponent,
                title: 'Reglamentos'
              },
              {
                path: 'general',
                component: GeneralPageComponent,
                title: 'Configuración general'
              },
              {
                path: 'address',
                component: AddressPageComponent,
                title: 'Dirección de colonia'
              },
              {
                path: 'passes',
                component: SettingsPassesPageComponent,
                title: 'Configuración de pases'
              },
              {
                path: 'payments',
                component: SettingsPaymentsPageComponent,
                title: 'Configuración de pagos'
              }

            ]
          },
          {
            path: 'logs',
            children: [
              {
                path: 'sos',
                component: SosLogsPageComponent,
                title: 'Botón de emergencia'
              },
              {
                path: 'external-services',
                component: ExternalServiceLogsPageComponent,
                title: 'Servicios externos'
              },
              {
                path: 'external-services/:externalServiceLogId',
                component: ExternalServiceLogPageComponent,
                title: 'Detalle de bitácora de servicio externo'
              },
            ]
          },
          {
            path: 'surveys',
            children: [
              {
                path: '',
                component: SurveysPageComponent,
                title: 'Encuestas'
              },
              {
                path: ':surveyId',
                component: SurveyPageComponent,
                title: 'Detalle de encuesta'
              }
            ]
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
